/* Carfy dark/light mode toggle. Persists in localStorage, defaults to light. */
(function () {
  var KEY = 'carfy-theme';
  function current() {
    try {
      return localStorage.getItem(KEY) || document.documentElement.getAttribute('data-theme') || 'light';
    } catch (e) {
      return 'light';
    }
  }
  function apply(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(KEY, theme);
    } catch (e) {}
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', theme === 'dark' ? '#0c0d12' : '#ffffff');
    document.querySelectorAll('[data-carfy-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(theme === 'dark'));
      btn.setAttribute('aria-label', theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
    });
    document.dispatchEvent(new CustomEvent('carfy:theme-changed', { detail: { theme: theme } }));
  }
  window.CarfyTheme = { current: current, apply: apply };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carfy-theme-toggle]');
    if (!btn) return;
    e.preventDefault();
    apply(current() === 'dark' ? 'light' : 'dark');
  });
  apply(current());
})();
